// extracted by mini-css-extract-plugin
module.exports = {"otherInput":"OtherInput_otherInput__2s0pX"};